class ResumePoints {
    resumeFrom = 0;
    updateIntervalMs = -1;
    isEnabled = false;

    constructor() {
        Object.seal(this);
    }
}

export default ResumePoints;
